import {configureStore} from '@reduxjs/toolkit';
import {api} from '~/ViewInvitation/api/api';
import {rootReducer} from './reducers';
import {promiseResolverMiddleware} from '~/common/middleware/promiseResolver';

export const middlewares = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }).concat(api.middleware, promiseResolverMiddleware);

export function createInvitationStore(initialState) {
  return configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: middlewares,
  });
}
